
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us-economy/yield-curve",
      function () {
        return require("private-next-pages/us-economy/yield-curve.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us-economy/yield-curve"])
      });
    }
  